
import { ComboBox, IComboBoxOption } from "@fluentui/react";
import PoolDropdown from "../../jobManualView/PoolDropdown";
import { withAllFirst, serializePools, type SelectedKey } from "../../../helpers/PoolSelectionHelper";
import { JOB_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { CREATE_MANUAL_JOB_TITLE, USAGE_TO_LICENSE_MATCHING_JOB_TYPE } from "../../../Consts";
import { JobParameterControlFactory } from "../../../helpers/JobParameterControlFactory";
import { IGenericJobTypeLookupInstance } from "../../../types/IGenericJobTypeLookupInstance";
import { IJobParameterControlBaseDistribution } from "../../../types/JobParameterControls/IJobParameterControlBaseDistribution";
import TextDataInput from "../../../../repertoire/components/textDataInput/TextDataInput";
import React from "react";
import { getLookupValues, getOptions } from "../../../helpers/UsageJobFormFieldsHelper";
import ActionButton from "../../../../repertoire/components/actionButton/ActionButton";
import { JOB_CREATED_VIEW } from "../../../../repertoire/Consts";
import { MessageBanner, MessageType } from "../../../../repertoire/components/messageBanner/MessageBanner";
import { isValidCronExpression } from "../../../../util/cronValidation";

const DISTRIBUTION = "ULM_Distribution";
const POOL = "ULM_Pool";
const MATCH_TYPE = "ULM_MatchType";
const SCHEDULE = "ULM_Schedule"

const ULMFormFieldsView = ({
    triggerManualJob,
    createNewJob,
    lookups,
    manualJobDataSources,
    getScheduledJob,
    upsertScheduledJobAsync,
    scheduledJob,
    showModal,
    scheduledJobSet,
    onError


}) => {
    const [jobControls, setJobControls] = React.useState([]);
    const [distributionValue, setDistributionValue] = React.useState('');
    const [poolValue, setPoolValue] = React.useState<SelectedKey[]>([]);
    const [poolOptions, setPoolOptions] = React.useState<IComboBoxOption[]>([]);
    const [matchTypeValue, setMatchTypeValue] = React.useState('');
    const [scheduledValue, setScheduledValue] = React.useState('');
    const [cronError, setCronError] = React.useState('');
    const [scheduleJobSet, setScheduleJobSet] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const jobTypes = getLookupValues(JOB_TYPE_LOOKUP, lookups, USAGE_TO_LICENSE_MATCHING_JOB_TYPE) as IGenericJobTypeLookupInstance;

        if (jobTypes.extraFields.GenericParametersJson && (jobTypes.extraFields.GenericParametersJson != '')) {
            let genericJobBaseParameters = JSON.parse(jobTypes.extraFields.GenericParametersJson) as { controlList: IJobParameterControlBaseDistribution[] }
            let jobControls = JobParameterControlFactory.InstantiateControlList(genericJobBaseParameters.controlList, manualJobDataSources) as IJobParameterControlBaseDistribution[];
            setJobControls(jobControls);
            jobControls.forEach(formItem => {
                if (formItem.ControlID === DISTRIBUTION) {
                    setDistributionValue(formItem.CurrentValue as string)
                }
                if (formItem.ControlID === POOL) {
                    setPoolValue(formItem.CurrentValue ? [...formItem.CurrentValue] : []);
                }
                if (formItem.ControlID === MATCH_TYPE) {
                    setMatchTypeValue(formItem.CurrentValue as string)
                }
            })
        }


    }, []);

    React.useEffect(() => {
        if (poolValue.length > 0 && distributionValue && matchTypeValue) {
            getScheduledJob(
                USAGE_TO_LICENSE_MATCHING_JOB_TYPE,
                JSON.stringify({ controlList: formatparams() })
            );
        }
    }, [poolValue, distributionValue, matchTypeValue]);

    React.useEffect(() => {
        if (scheduledJob) {
            setScheduledValue(scheduledJob.cronSchedule)
        }
    }, [scheduledJob]);

    const handleDistributionChange = (option?: IComboBoxOption) => {
        if (!option) return;

        setDistributionValue(option.key as string);

        const poolControl = jobControls.find(c => c.ControlID === POOL);
        let raw = poolControl
        ? ((getOptions(poolControl, option.key as string, true) || []) as IComboBoxOption[])
        : [];

        setPoolOptions(raw);
        setPoolValue([]);
        setScheduledValue('')
    }

    const handleMatchTypeChange = (value: IComboBoxOption) => {
        setMatchTypeValue(value.key as string)
        setScheduledValue('')
    }
    const handleScheduleChange = (value: string | number | boolean, fieldname: string) => {
        setScheduledValue(value as string);
        setCronError('');
    }

    const formatparams = () => {
        return jobControls.map(control => {
            if (control.ControlID === DISTRIBUTION) {
                return { ControlID: control.ControlID, CurrentValue: distributionValue }
            }
            if (control.ControlID === POOL) {
                return {
                    ControlID: control.ControlID,
                    CurrentValue: serializePools(poolValue, withAllFirst(poolOptions))
                }
            }
            if (control.ControlID === MATCH_TYPE) {
                return { ControlID: control.ControlID, CurrentValue: matchTypeValue }
            }
        })
    }

    const setParamsAndTriggerManualJob = () => {
        let params = JSON.stringify({ controlList: formatparams() });
        return triggerManualJob({ jobType: USAGE_TO_LICENSE_MATCHING_JOB_TYPE, jobParameters: params });
    }

    const getFormComponents = (jobControls) => {
        return jobControls.map(formItem => {

            if (formItem.Type === 'combobox' && formItem.ControlID === DISTRIBUTION) {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <div className="dropdownDataInput">
                            <ComboBox
                                selectedKey={distributionValue}
                                data-testid="ULM_Distribution"
                                label={formItem.Caption}
                                options={getOptions(formItem, distributionValue)}
                                onChange={(e, selectedOption, i, value) => {
                                    if (selectedOption) // Handle when a custom value is typed
                                        handleDistributionChange(selectedOption);
                                }}
                                useComboBoxAsMenuWidth
                                calloutProps={{ calloutMaxHeight: 270 }}
                                autoComplete="on"
                                allowFreeform={true}
                            />
                        </div>
                    </div>
                );
            }

            if (formItem.Type === 'combobox' && formItem.ControlID === POOL) {

                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <div className="dropdownDataInput">
                            <PoolDropdown
                                data-testid="ULM_Pool"
                                label={formItem.Caption}
                                poolOptions={poolOptions}
                                value={poolValue}
                                onChange={setPoolValue}
                                disabled={!distributionValue}
                            />
                        </div>
                    </div>
                );
            }

            if (formItem.Type === 'combobox' && formItem.ControlID === MATCH_TYPE) {


                return (<div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <div className="dropdownDataInput">
                        <ComboBox
                            selectedKey={matchTypeValue}
                            data-testid="ULM_MatchType"
                            label={formItem.Caption}
                            options={getOptions(formItem, distributionValue)}
                            onChange={(e, selectedOption, i, value) => {
                                handleMatchTypeChange(selectedOption);
                            }}
                            useComboBoxAsMenuWidth
                            calloutProps={{ calloutMaxHeight: 270 }}
                        />
                    </div>
                </div>
                );
            }
        })
    }

    const dismissAlert = () => {
        setCronError('');
    };


    const setSchedule = async () => {
        const valid = isValidCronExpression(scheduledValue); // Evaluate validity immediately
        setLoading(true);
        let schedule = {
            cronSchedule: scheduledValue,
            errorList: [],
            lastRunDate: null,
            parameters: JSON.stringify({ controlList: formatparams() }),
            type: USAGE_TO_LICENSE_MATCHING_JOB_TYPE
        };
        if (valid) {
            setCronError('');
            try {
                await upsertScheduledJobAsync(schedule);
                scheduledJobSet(true);
                createNewJob();
            } catch (err: any) {
                onError?.(err?.message || err?.toString() || "An error occurred");
            } finally {
                setLoading(false);
            }
        } else {
            setCronError('Please enter a valid Schedule expression.');
            setLoading(false);
        }
    }

    const onClick = async () => {
        setLoading(true);
        try {
            scheduledJobSet(true);
            createNewJob();
            await setParamsAndTriggerManualJob();
        } catch (err: any) {
            onError?.(err?.message || err?.toString() || "An error occurred");
            scheduledJobSet(false);
        } finally {
            setLoading(false);
        }
    }

    const isValidJob = () => {
        return Boolean(distributionValue && matchTypeValue && poolValue.length > 0)
    }

    return <>
        <div className="row">
            {jobControls && getFormComponents(jobControls)}
        </div>
        <div className="row">

            <div className="form-group col-md-4 col-sm-6 col-xs-12">
                <TextDataInput
                    label={"Schedule"}
                    data-testid="ULM_Schedule"
                    fieldName={SCHEDULE}
                    changeData={handleScheduleChange}
                    value={scheduledValue}
                    readOnly={!(isValidJob())}
                    isHidden={false}
                    isMandatory={false}
                />
            </div>
            <div style={{ marginTop: 12 }} className="form-group col-md-2 col-sm-4 col-xs-12">
                <ActionButton buttonText={"Set"} buttonAction={setSchedule} data-testid="Set-action-button" disabled={!(isValidJob()) || loading} />
            </div>
        </div>

        {cronError && cronError !== '' && (
            <div className="alert alert-danger alert-dismissible">
                <span data-testid="ScheduleError">{cronError}</span>
                <button type="button" className="close" aria-label="Close" data-testid="Create Manual Job-action-button" onClick={dismissAlert}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        )}

        <div className="row">
            <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <ActionButton buttonText={"Cancel"} buttonAction={createNewJob} className={"button btn-defaultSecondary"}/>
            </div>
            <div className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                <ActionButton buttonText={CREATE_MANUAL_JOB_TITLE} buttonAction={onClick} disabled={!(isValidJob()) || loading}/>
            </div>
        </div>
    </>
}

export default ULMFormFieldsView;